export const ALPHANUMERIC_CODES_BASE = [41, 21, 22, 42, 47, 48, 50];
